import styled from 'styled-components';

const TableHeaderEvolve = styled.div`
  display: flex;
  color: #FFFFFF;
  align-items: center;
  justify-content: space-around;

  div{
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default TableHeaderEvolve;
